export default function(request, reject, rootAddress) {
  var service = {};
  /**
		获取全局配置
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/get_config

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "is_bind_phone": true,
		        "bind_phone": "159***248",
		        "session_id": "kL2aoCT2B3DNFJ0pSX8mhnkPj0wblVJ2ETVHd6Qh",
		        "request_id": "6158d7903ae9496d6fcbf560d0df2c1c7ac38af0"
		    }
		}
		*/
  service.getConfig = function() {
    return request.jsonp(rootAddress + '/jx/modifyphone/get_config', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "bind_phone": "绑定手机号(加密)",
            "is_bind_phone": "是否有绑定手机"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		验证真实姓名和身份证是否一致
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/verify_identify?real_name=谭健成&id_num_last_six_num=318038

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "token": "5f856b9d51dc5",
		        "session_id": "uAq4uVV5yuHLIL8SjxG9J4JDa3jDkAmlKqCJyRFa",
		        "request_id": "fa496aaec7d1b42feac9dcd6ecba267dc8b539c6"
		    }
		}
		*/
  service.verifyIdentify = function(real_name, id_num_last_six_num) {
    return request.jsonp(rootAddress + '/jx/modifyphone/verify_identify', {
      real_name: real_name /*  真实姓名 */ ,
      id_num_last_six_num: id_num_last_six_num /*  身份证后6位 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "token": "校验token（用于bind_new_phone_with_tokenA接口）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10113",
        "description": "姓名为空"
      }, {
        "code": "-10114",
        "description": "姓名格式不合法"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }, {
        "code": "-20101",
        "description": "请填写真实姓名"
      }, {
        "code": "-20102",
        "description": "请填写身份证后六位"
      }, {
        "code": "-20201",
        "description": "该通行证没有绑定身份证"
      }, {
        "code": "-20202",
        "description": "该通行证没有真实姓名相关信息"
      }, {
        "code": "-20203",
        "description": "真实姓名不匹配"
      }, {
        "code": "-20204",
        "description": "身份证后6位不匹配"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		get_phone_code
		请求方法: GET, POST
		请求示例:
		响应示例:
		*/
  service.getPhoneCode = function(params) {
    return request.jsonp(rootAddress + '/jx/modifyphone/get_phone_code', {
      phone:params.phone,
      check_old_phone:params.checkOldPhone,
      captcha:'',
      geetest_challenge: params.geetest_challenge,
      geetest_seccode: params.geetest_seccode,
      geetest_validate: params.geetest_validate
    }).then((response) => {

      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10303",
        "description": "短信内容为空"
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10308",
        "description": "短信验证码发送数量达到每日上限"
      }, {
        "code": "-10309",
        "description": "短信验证码发送频率太快"
      }, {
        "code": "-10601",
        "description": "图片验证码为空"
      }, {
        "code": "-10602",
        "description": "图片验证码错误"
      }, {
        "code": "-10603",
        "description": "验证失败"
      }, {
        "code": "-10604",
        "description": "图片验证码参数错误"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		绑定新手机(用户没有绑定过手机的情况)
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/bind_new_phone_with_token?token=5f85717abc92c&phone=15919175248&code=1234

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "session_id": "ognZGnrvkki8NdC2ogl0CZPhUtNXiP7imxbvGIWs",
		        "request_id": "667816421d5f72f2593f738b9694657437b71a81"
		    }
		}
		*/
  service.bindNewPhoneWithToken = function(token, phone, code) {
    return request.jsonp(rootAddress + '/jx/modifyphone/bind_new_phone_with_token', {
      token: token /*  校验token */ ,
      phone: phone /*  手机号码 */ ,
      code: code /*  手机验证码 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }, {
        "code": "-20301",
        "description": "token为空"
      }, {
        "code": "-20302",
        "description": "短信验证码为空"
      }, {
        "code": "-20303",
        "description": "token无效"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		验证原手机
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/verify_old_phone?phone=15919175249&code=1234

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "session_id": "iE3XHdyLK8iK8cJmT008hKKcx3SOXnnP0Bokrl0u",
		        "request_id": "9e1e96787ad27f24ebc4dfa3b95aaced73bd835d"
		    }
		}
		*/
  service.verifyOldPhone = function(phone, code) {
    return request.jsonp(rootAddress + '/jx/modifyphone/verify_old_phone', {
      phone: phone /*  新手机号码 */ ,
      code: code /*  手机验证码 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10303",
        "description": "短信内容为空"
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }, {
        "code": "-20401",
        "description": "该通行证没有绑定手机"
      }, {
        "code": "-20402",
        "description": "请输入新绑定的手机号"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		更改绑定手机(用户已绑定过手机的情况)
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/bind_new_phone_with_upsms?phone=15919175249

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "session_id": "xWYsVRFHqEJqpetEDbEgJ6QY0gsxhvN090QVS1s3",
		        "request_id": "795e539e2994c87cec98c37970f5be8db3d77b69"
		    }
		}
		*/
  service.bindNewPhoneWithUpsms = function(phone) {
    return request.jsonp(rootAddress + '/jx/modifyphone/bind_new_phone_with_upsms', {
      phone: phone /*  新手机号码 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }, {
        "code": "-20402",
        "description": "请输入新绑定的手机号"
      }, {
        "code": "-20403",
        "description": "请先按相关短信内容提示操作回复短信"
      }, {
        "code": "-20404",
        "description": "手机号非之前验证短信的号码"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		上行短信回调地址
		请求方法: GET, POST
		请求示例:
		响应示例:
		*/
  service.callback = function() {
    return request.jsonp(rootAddress + '/jx/modifyphone/callback', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };

  return service;
}



// WEBPACK FOOTER //
// ./src/services/zt/zt.js